import { render, staticRenderFns } from "./Shaped.vue?vue&type=template&id=91b4f6b2&"
import script from "./Shaped.vue?vue&type=script&lang=js&"
export * from "./Shaped.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports